import React from 'react';
import { FadeIn } from './FadeIn';
import { Sun, ThermometerSnowflake, Utensils } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Sun className="w-8 h-8" data-id="element-118" />,
    title: 'Baño de Fotones matutino',
    desc: 'Para resetear tu reloj interno.'
  }, {
    icon: <ThermometerSnowflake className="w-8 h-8" data-id="element-119" />,
    title: 'Protocolo Térmico antes de cenar',
    desc: 'Para bajar la temperatura del núcleo.'
  }, {
    icon: <Utensils className="w-8 h-8" data-id="element-120" />,
    title: 'Anclaje de Glucosa Nocturna',
    desc: 'Para evitar el despertar de las 3 AM.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <FadeIn data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-white" data-id="element-124">
            Cómo funciona:
          </h2>
        </FadeIn>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-navy-600 before:to-transparent" data-id="element-125">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-126">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-127">
                <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-navy-800 bg-navy-900 text-amber-500 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 relative z-10" data-id="element-128">
                  {step.icon}
                </div>
                <div className="w-[calc(100%-5rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-navy-900 border border-navy-700 shadow-lg" data-id="element-129">
                  <div className="flex items-center justify-between mb-2" data-id="element-130">
                    <span className="font-bold text-amber-500 text-sm tracking-widest uppercase" data-id="element-131">
                      Paso {index + 1}
                    </span>
                  </div>
                  <h3 className="font-bold text-xl text-white mb-2" data-id="element-132">
                    {step.title}
                  </h3>
                  <p className="text-lavender-200" data-id="element-133">{step.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}